// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"5ac20f12","938":"12e1f4f0"}[chunkId] + ".chunk.js";
};